import { render, staticRenderFns } from "./ProfileSkills.vue?vue&type=template&id=0166b47d&"
import script from "./ProfileSkills.vue?vue&type=script&lang=js&"
export * from "./ProfileSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports